import React, { useContext, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { NavContext } from 'src/context/nav-context';
import { merchantProfileRoute } from 'src/routing/routes';
import './header-nav.scss';

type HeaderNavProps = {
  title?: string;
  screenName?: string;
  children: React.ReactNode;
};

export default function HeaderNav({ title, screenName, children }: HeaderNavProps) {
  const { showNav, setShowNav } = useContext(NavContext);
  const [redirectToProfile, setRedirectToProfile] = useState(false);

  return (
    <>
      <div className="HeaderNav">
        {redirectToProfile && <Redirect push to={merchantProfileRoute} />}
        <div className="header">
          <div className="columns is-mobile is-gapless is-vcentered">
            <div
              className="column is-one-fifth is-hidden-tablet"
              onClick={() => {
                setShowNav(!showNav);
              }}
              automationid="Menu_Side_Nav_Div_Button_Expand_From_Header_Nav_Bar"
            >
              <span className="is-icon-3 navbar-icon icon-burger-menu"></span>
            </div>
            {title && (
              <div
                className={`navbar-title column is-three-fifths ${
                  screenName ? 'is-hidden-mobile' : ''
                }`}
              >
                {title}
              </div>
            )}
            {screenName && (
              <div className="navbar-title column is-three-fifths navbar-title-mobile is-hidden-tablet">
                {screenName}
              </div>
            )}
            <div className="column">
              <div
                className="navbar-end-item"
                onClick={() => {
                  setRedirectToProfile(true);
                }}
                automationid="Merchant_Profile_Div_Button_Header_Nav_Bar_Shortcut"
              >
                <span className="navbar-icon is-icon-4 icon-user"></span>
              </div>
            </div>
          </div>
          <hr className="divider is-hidden-mobile" />
        </div>
        <div className="body">
          <div className="body-content">{children}</div>
        </div>
      </div>
    </>
  );
}
